import React from "react";

import "./App.css";
import Header from "./Shared/Header/Header";
import Feeds from "./Shared/Feeds/Feeds";
import { Route, Routes } from "react-router-dom";
import PostDetails from "./Shared/PostDetails/PostDetails";
import Menu from "./Shared/Menu/Menu";
import CampusLife from "./Shared/CampusLife/CampusLife";
import CampusNews from "./Shared/CampusNews/CampusNews";
import AboutUs from "./Shared/AboutUs/AboutUs";
import PrivacyPolicy from "./Shared/PrivacyPolicy/PrivacyPolicy";
import Notices from "./Shared/Notices/Notices";
import Admission from "./Shared/Admission/Admission";
import Credit from "./Shared/Credit/Credit";
import ContactUs from "./Shared/ContactUs/ContactUs";

function App() {
  return (
    <div className="bg-white">
      <Routes>
        <Route path="/" element={<Feeds></Feeds>}></Route>
        <Route path="/feeds" element={<Feeds></Feeds>}></Route>

        <Route
          path={"/postDetails/:postID"}
          element={<PostDetails></PostDetails>}
        ></Route>

        <Route path="/menu" element={<Menu></Menu>}></Route>
        <Route path="/CampusLife" element={<CampusLife></CampusLife>}></Route>
        <Route path="/CampusNews" element={<CampusNews></CampusNews>}></Route>
        <Route path="/AboutUs" element={<AboutUs></AboutUs>}></Route>
        <Route
          path="/PrivacyPolicy"
          element={<PrivacyPolicy></PrivacyPolicy>}
        ></Route>
        <Route path="/Notices" element={<Notices></Notices>}></Route>
        <Route path="/Admission" element={<Admission></Admission>}></Route>
        <Route path="/Credits" element={<Credit></Credit>}></Route>
        <Route path="/ContactUs" element={<ContactUs></ContactUs>}></Route>
      </Routes>

      <div className="pt-[70px]"></div>

      <Header className=""></Header>
    </div>
  );
}

export default App;

// Note :::

///  React: How to Check Internet Connection (Online/Offline)
/// https://www.kindacode.com/article/react-how-to-check-internet-connection-online-offline/
